var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReceipt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66602 1.33301V14.6663L3.99935 13.9997L5.33268 14.6663L6.66602 13.9997L7.99935 14.6663L9.33268 13.9997L10.666 14.6663L11.9993 13.9997L13.3327 14.6663V1.33301L11.9993 1.99967L10.666 1.33301L9.33268 1.99967L7.99935 1.33301L6.66602 1.99967L5.33268 1.33301L3.99935 1.99967L2.66602 1.33301Z",
    stroke: "#FF0400",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6673 5.33301H6.66732C6.3137 5.33301 5.97456 5.47348 5.72451 5.72353C5.47446 5.97358 5.33398 6.31272 5.33398 6.66634C5.33398 7.01996 5.47446 7.3591 5.72451 7.60915C5.97456 7.8592 6.3137 7.99967 6.66732 7.99967H9.33398C9.68761 7.99967 10.0267 8.14015 10.2768 8.3902C10.5268 8.64025 10.6673 8.97939 10.6673 9.33301C10.6673 9.68663 10.5268 10.0258 10.2768 10.2758C10.0267 10.5259 9.68761 10.6663 9.33398 10.6663H5.33398",
    stroke: "#FF0400",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.6663V4.33301",
    stroke: "#FF0400",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/receipt.9ef5020ccbab03bff67cdc16387b2602.svg";
export { ForwardRef as ReactComponent };